import Suber from "./Suber";

export default Suber;